/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { ROOT_URL_V2 } from '../../../config';
import { fetchLoggedInAsync } from '../../../actions/ClientData';
import history from '../../../history';

function getRedirectUrl() {
    const redirectParam = new URLSearchParams(history.location.search).get('redirect');
    if (!redirectParam || redirectParam === 'null' || redirectParam === 'undefined') {
        return null;
    }
    return decodeURI(redirectParam);
}

function getExchangeErrorMessage(error) {
    const status = error?.response?.status;
    const suffix = ' Please open the client portal from the app again, or log in directly here.';
    if (status === 410) {
        return `This login link has expired.${suffix}`;
    }
    if (status === 401) {
        return `This login link is invalid or has already been used.${suffix}`;
    }
    return `Unable to sign you in automatically.${suffix}`;
}

function redirectWithAutoLoginError(message) {
    history.replace({
        pathname: '/client/login',
        state: { autoLoginError: message },
    });
}

class AutoLogin extends Component {
    componentDidMount() {
        const { loggedIn, dispatch } = this.props;
        const urlParams = new URLSearchParams(history.location.search);
        const token = urlParams.get('token');
        const redirectUrl = getRedirectUrl();

        if (loggedIn) {
            this.redirect(redirectUrl);
            return null;
        }

        if (token) {
            const self = this;
            // Exchange short-lived one-time webview JWT for a DRF token, then sync session.
            axios
                .post(`${ROOT_URL_V2}user/webview-token/exchange/`, { token })
                .then(response => {
                    const drfToken = response.data.content.token;
                    return axios({
                        method: 'GET',
                        url: `${ROOT_URL_V2}user/login/`,
                        headers: { Authorization: `Token ${drfToken}` },
                    });
                })
                .then(() => {
                    dispatch(
                        fetchLoggedInAsync((resp, error) => {
                            if (error) {
                                redirectWithAutoLoginError(
                                    'Unable to load your account after sign-in. Please try again, or log in directly here.',
                                );
                            } else {
                                self.redirect(redirectUrl);
                            }
                        }),
                    );
                })
                .catch(error => {
                    redirectWithAutoLoginError(getExchangeErrorMessage(error));
                });
        } else {
            redirectWithAutoLoginError(
                'Missing login token. Please open the client portal from the app again, or log in directly here.',
            );
        }
    }

    redirect(redirectUrl) {
        if (redirectUrl) {
            if (redirectUrl.includes('checkout')) {
                history.push({
                    pathname: redirectUrl,
                    state: { mode: 'checkout' },
                });
            } else {
                history.push(redirectUrl);
            }
        } else {
            history.push('/');
        }
    }

    render() {
        return (
            <div className="initial-loading">
                <i className="icon icon-loading-1" />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.user.loggedIn,
    };
}

export default withRouter(connect(mapStateToProps)(AutoLogin));
